
export function ccform(apiKey) {
  var submit = document.getElementById('payway-cc-submit');
  var style = {
    // '.payway-creditcard-testfacility': { 'display': 'none' },
    '.payway-card': { 'font-size': '13px !important', "margin": "0 !important" },
    '.payway-account': { 'font-size': '13px !important', "margin": "0 !important" }
  };

  var tokenCallback = function (err, data) {
    if (err) {
      console.log('error=' + err.message);
    } else {
      document.getElementById("msg").innerHTML = '';
      document.getElementById('msg').innerHTML += data.singleUseTokenId;

      document.getElementById("card_type").innerHTML = '';
      document.getElementById("card_type").innerHTML += data.creditCard.cardScheme;

      // TODO: Send token to your server via AJAX
    }
  };

  var createdCallback = function (err, frame) {
    if (!err) {
      submit.addEventListener("click", function () {
        frame.getToken(tokenCallback);
      });
    }
  };


  payway.createCreditCardFrame({
    publishableApiKey: apiKey,
    onValid: function () { submit.disabled = false; },
    onInvalid: function () { submit.disabled = true; },
    style: style,
    tokenMode: 'callback'
  },
    createdCallback
  );
}

export function ccform_callback(apiKey, onValid, onInvalid) {

  var submit = document.getElementById('payway-cc-submit');

  var style = {
    // '.payway-creditcard-testfacility': { 'display': 'none' },
    '.payway-card': { 'font-size': '13px !important', "margin": "0 !important" },
    '.payway-account': { 'font-size': '13px !important', "margin": "0 !important" }
  };

  var tokenCallback = function (err, data) {
    if (err) {
      console.log('error=' + err.message);
    } else {
      document.getElementById("msg").innerHTML = '';
      document.getElementById('msg').innerHTML += data.singleUseTokenId;

      document.getElementById("card_type").innerHTML = '';
      document.getElementById("card_type").innerHTML += data.creditCard.cardScheme;

      // TODO: Send token to your server via AJAX
    }
  };

  var createdCallback = function (err, frame) {
    if (!err) {
      submit.addEventListener("click", function () {
        frame.getToken(tokenCallback);
      });
    }
  };


  payway.createCreditCardFrame({
    publishableApiKey: apiKey,
    onValid: onValid,
    onInvalid: onInvalid,
    style: style,
    tokenMode: 'callback'
  },
    createdCallback
  );
}


export function baform(apiKey) {
  var submit = document.getElementById('payway-ba-submit');
  var style = {
    '.payway-account-testfacility': { 'display': 'none' }
  };

  var tokenCallback = function (err, data) {
    if (err) {
      console.log('error=' + err.message);
    } else {
      document.getElementById("msg").innerHTML = '';
      document.getElementById('msg').innerHTML += data.singleUseTokenId;
      // TODO: Send token to your server via AJAX
    }
  };

  var createdCallback = function (err, frame) {
    if (!err) {
      submit.addEventListener("click", function () {
        frame.getToken(tokenCallback);
      });
    }
  };

  payway.createBankAccountFrame({
    publishableApiKey: apiKey,
    onValid: function () { submit.disabled = false; },
    onInvalid: function () { submit.disabled = true; },
    style: style,
    tokenMode: 'callback'
  },
    createdCallback
  );
}

export function copyFromSelectEndUser(selectEndUserModel) {

  var salesType = $('.tab-pane.active').attr('id');

  var shippingCompany = selectEndUserModel.out_company_name;
  var shippingAttRef = selectEndUserModel.out_display_name;
  var shippingAddress1 = selectEndUserModel.out_address_1;
  var shippingAddress2 = selectEndUserModel.out_address_2;
  var shippingAddress3 = selectEndUserModel.out_address_3;
  var shippingState = selectEndUserModel.out_state;
  var shippingSuburb = selectEndUserModel.out_suburb;
  var shippingPostCode = selectEndUserModel.out_postcode;
  var shippingPhone = selectEndUserModel.out_phone;
  var shippingCountry = selectEndUserModel.out_country;
  var shippingEmail = selectEndUserModel.out_email;
  var resellerEmail = selectEndUserModel.out_user_only_20;

  if ($('#' + salesType + "_out_company_name").length && !$('#' + salesType + "_out_company_name").val()) {
    $('#' + salesType + "_out_company_name").val(shippingCompany);
  }

  if ($('#' + salesType + "_out_display_name").length && !$('#' + salesType + "_out_display_name").val()) {
    $('#' + salesType + "_out_display_name").val(shippingAttRef);
  }

  if ($('#' + salesType + "_out_address_1").length && !$('#' + salesType + "_out_address_1").val()) {
    $('#' + salesType + "_out_address_1").val(shippingAddress1);
  }

  if ($('#' + salesType + "_out_address_2").length && !$('#' + salesType + "_out_address_2").val()) {
    $('#' + salesType + "_out_address_2").val(shippingAddress2);
  }

  if ($('#' + salesType + "_out_address_3").length && !$('#' + salesType + "_out_address_3").val()) {
    $('#' + salesType + "_out_address_3").val(shippingAddress3);
  }

  if ($('#' + salesType + "_out_state").length && !$('#' + salesType + "_out_state").val()) {
    $('#' + salesType + "_out_state").val(shippingState.toUpperCase());
  }

  if ($('#' + salesType + "_out_suburb").length && !$('#' + salesType + "_out_suburb").val()) {
    $('#' + salesType + "_out_suburb").val(shippingSuburb);
  }

  if ($('#' + salesType + "_out_postcode").length && !$('#' + salesType + "_out_postcode").val()) {
    $('#' + salesType + "_out_postcode").val(shippingPostCode);
  }

  if ($('#' + salesType + "_out_phone").length && !$('#' + salesType + "_out_phone").val()) {
    $('#' + salesType + "_out_phone").val(shippingPhone);
  }
  if ($('#' + salesType + "_out_country").length && !$('#' + salesType + "_out_country").val()) {
    $('#' + salesType + "_out_country").val(shippingCountry);
  }
  if ($('#' + salesType + "_out_email").length && !$('#' + salesType + "_out_email").val()) {
    $('#' + salesType + "_out_email").val(shippingEmail);
  }
  if ($('#' + salesType + "_out_user_only_20").length && !$('#' + salesType + "_out_user_only_20").val()) {
    $('#' + salesType + "_out_user_only_20").val(resellerEmail);
  }
}

export function copyFromShipInfo(shippingAddressModel, switchCopy) {

  var salesType = $('.tab-pane.active').attr('id');
  if (switchCopy) {
    var shippingCompany = shippingAddressModel.addressGroup.companyName;
    var shippingAttRef = shippingAddressModel.addressGroup.attnOrRef;
    var shippingAddress1 = shippingAddressModel.addressGroup.addressLine1;
    var shippingAddress2 = shippingAddressModel.addressGroup.addressLine2;
    var shippingAddress3 = shippingAddressModel.addressGroup.addressLine3;
    var shippingState = shippingAddressModel.addressGroup.state;
    var shippingSuburb = shippingAddressModel.addressGroup.suburb;
    var shippingPostCode = shippingAddressModel.addressGroup.postcode;
    var shippingPhone = shippingAddressModel.addressGroup.phone;

    var fieldExist = false;
    if ($('#' + salesType + "_out_company_name").length) {
      fieldExist = true;
      $('#' + salesType + "_out_company_name").val(shippingCompany);
    }

    if ($('#' + salesType + "_out_display_name").length) {
      fieldExist = true;
      $('#' + salesType + "_out_display_name").val(shippingAttRef);
    }

    if ($('#' + salesType + "_out_address_1").length) {
      fieldExist = true;
      $('#' + salesType + "_out_address_1").val(shippingAddress1);
    }

    if ($('#' + salesType + "_out_address_2").length) {
      fieldExist = true;
      $('#' + salesType + "_out_address_2").val(shippingAddress2);
    }

    if ($('#' + salesType + "_out_address_3").length) {
      fieldExist = true;
      $('#' + salesType + "_out_address_3").val(shippingAddress3);
    }

    if ($('#' + salesType + "_out_state").length) {
      fieldExist = true;
      $('#' + salesType + "_out_state").val(shippingState.toUpperCase());
    }

    if ($('#' + salesType + "_out_suburb").length) {
      fieldExist = true;
      $('#' + salesType + "_out_suburb").val(shippingSuburb);
    }

    if ($('#' + salesType + "_out_postcode").length) {
      fieldExist = true;
      $('#' + salesType + "_out_postcode").val(shippingPostCode);
    }

    if ($('#' + salesType + "_out_phone").length) {
      fieldExist = true;
      $('#' + salesType + "_out_phone").val(shippingPhone);
    }
    if (fieldExist) {
      $('.tab-pane.active .btnCopyShipAddr').showValidator('Info copied.', 'success', 'right');
    } else {
      $('.tab-pane.active .btnCopyShipAddr').showValidator('Fail to copy info.', 'error', 'right');
    }

    return fieldExist;
  } else {
    $('#' + salesType + "_out_company_name").val('');

    $('#' + salesType + "_out_display_name").val('');

    $('#' + salesType + "_out_address_1").val('');

    $('#' + salesType + "_out_address_2").val('');

    $('#' + salesType + "_out_address_3").val('');

    $('#' + salesType + "_out_state").val('');

    $('#' + salesType + "_out_suburb").val('');

    $('#' + salesType + "_out_postcode").val('');

    $('#' + salesType + "_out_phone").val('');
  }
}

export function copyBrands(switchCopy) {
  var currentSalesType = $('.tab-pane.active').attr('id');
  if (switchCopy) {
    console.info(switchCopy);
    var shippingCompany = $('#' + currentSalesType + "_out_company_name").val();
    var shippingAttRef = $('#' + currentSalesType + "_out_display_name").val();
    var shippingAddress1 = $('#' + currentSalesType + "_out_address_1").val();
    var shippingAddress2 = $('#' + currentSalesType + "_out_address_2").val();
    var shippingAddress3 = $('#' + currentSalesType + "_out_address_3").val();
    var shippingState = $('#' + currentSalesType + "_out_state").val();
    var shippingSuburb = $('#' + currentSalesType + "_out_suburb").val();
    var shippingPostCode = $('#' + currentSalesType + "_out_postcode").val();
    var shippingPhone = $('#' + currentSalesType + "_out_phone").val();
    var shippingCountry = $('#' + currentSalesType + "_out_country").val();
    var shippingEmail = $('#' + currentSalesType + "_out_email").val();
    var shippingFax = $('#' + currentSalesType + "_out_fax").val();
    var isInfoCopied = false;
    $('.tab-content > div').each(function () {
      var salesType = $(this).attr('id');

      if (salesType != currentSalesType) {
        if (shippingCompany && $('#' + salesType + "_out_company_name").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_company_name").val(shippingCompany);
        }

        if (shippingAttRef && $('#' + salesType + "_out_display_name").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_display_name").val(shippingAttRef);
        }

        if (shippingAddress1 && $('#' + salesType + "_out_address_1").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_address_1").val(shippingAddress1);
        }

        if (shippingAddress2 && $('#' + salesType + "_out_address_2").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_address_2").val(shippingAddress2);
        }

        if (shippingAddress3 && $('#' + salesType + "_out_address_3").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_address_3").val(shippingAddress3);
        }

        if (shippingState && $('#' + salesType + "_out_state").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_state").val(shippingState.toUpperCase());
        }
        if (shippingSuburb && $('#' + salesType + "_out_suburb").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_suburb").val(shippingSuburb);
        }

        if (shippingPostCode && $('#' + salesType + "_out_postcode").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_postcode").val(shippingPostCode);
        }

        if (shippingPhone && $('#' + salesType + "_out_phone").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_phone").val(shippingPhone);
        }

        if (shippingEmail && $('#' + salesType + "_out_email").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_email").val(shippingEmail);
        }

        if (shippingFax && $('#' + salesType + "_out_fax").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_fax").val(shippingFax);
        }

        if (shippingCountry && $('#' + salesType + "_out_country").length) {
          isInfoCopied = true;
          $('#' + salesType + "_out_country").val(shippingCountry);
        }
      }
    });
    if (isInfoCopied) {
      $('.tab-pane.active .btnCopyAllBrands').showValidator('Info copied.', 'success', 'right');
    } else {
      $('.tab-pane.active .btnCopyAllBrands').showValidator('Fail to copy info.', 'error', 'right');
    }
    return isInfoCopied;
  } else {
    $('.tab-content > div').each(function () {
      var salesType = $(this).attr('id');
      $('#' + salesType + "_out_company_name").val('');

      $('#' + salesType + "_out_display_name").val('');

      $('#' + salesType + "_out_address_1").val('');

      $('#' + salesType + "_out_address_2").val('');

      $('#' + salesType + "_out_address_3").val('');

      $('#' + salesType + "_out_state").val('');

      $('#' + salesType + "_out_suburb").val('');

      $('#' + salesType + "_out_postcode").val('');

      $('#' + salesType + "_out_phone").val('');

      $('#' + salesType + "_out_email").val('');

      $('#' + salesType + "_out_fax").val('');

      $('#' + salesType + "_out_country").val('');
    });
  }
}

export function fillEndUserSelectionList() {
  var formSource = [];
  $('#v-pills-tabContent').remove();
  $('.reveal-content .end-user-ab-details').each(function () {
    var detail = '';
    var index = 0;
    $('#' + $(this).attr('id') + ' .form-row .input').each(function () {
      if (index == 6) {
        return false;
      }
      if ($(this).val() != "") {
        if (index == 0) {
          detail = "<b>";
        }
        detail += $(this).val() + " ";
        index += 1;
        if (index == 1) {
          detail += "</b><br/>";
        } else if (index == 4) {
          detail += "<br/>";
        }
      }
    });
    var source = {
      'label': detail, 'value': detail, 'id': $(this).attr('id'), 'salestype': $(this).attr('id').split('_')[1]
    };
    formSource.push(source);
  });

  //populate the selection list in End User Address Book
  var listItem = '<div class="tab-content col-sm-9 col-md-9" id="v-pills-tabContent">';
  listItem += '<div class="tab-pane fade show active" id="v-pills-' + formSource[0].salestype + '" role="tabpanel" aria-labelledby="v-pills-' + formSource[0].salestype + '-tab">';
  for (var i = 0; i < formSource.length; i++) {
    listItem += '<li>' + formSource[i].value + '<div><input type="hidden" value="' + formSource[i].id + '"/><a class="button button-red button-tiny eu-copy-all-brands">Copy to all Brands </a>&nbsp;&nbsp;<a class="button button-red button-tiny eu-copy-single-brand">Copy to ' + $('.endpopup .nav-link.active').html() + '</a></div></li>';
  }
  listItem += '</div>';
  listItem += '</div>';
  $('.reveal-content .row').append(listItem);
}

export function EndUserAddressBookTab() {
  $('.endpopup .nav-link').click(function () {
    $('.end-user-ab-details').remove();
    $('#v-pills-tabContent').remove();
    setTimeout(checkoutResult, 100);
  });
}

function checkoutResult() {
  var salesType = $('.endpopup .nav-link.active').attr('id').split('-')[2];
  $.ajax({
    url: 'api/checkout/EndUserAddressBookTemplate?salesType=' + salesType,
    type: 'GET',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (output) {
      $('.reveal-content .row').append(output);
      fillEndUserSelectionList();
      tabContentButtonClick();
    },
    error: function (request, status, error) {
      console.info(error);
    }
  })
}

export function tabContentButtonClick() {
  $('.eu-copy-all-brands').click(function (e) {
    var sectionId = $(this).siblings('input').val();
    var flag = copyTabSectionBrands(sectionId);
    if (flag) {
      $(this).showValidator('Vendor required info copied successfully.', 'success', 'right');
    } else {
      $(this).showValidator('Fail to copy vendor required info.', 'error', 'right');
    }
  });
  $('.eu-copy-single-brand').click(function (e) {
    var sectionId = $(this).siblings('input').val();
    var flag = copyBrandsInfo(sectionId);
    if (flag) {
      $(this).showValidator('Vendor required info copied successfully.', 'success', 'right');
    } else {
      $(this).showValidator($('.endpopup .nav-link.active').html() + ' product not found in cart.', 'error', 'right');
    }
  });
}

function copyTabSectionBrands(sectionId) {

  var prefixId = sectionId.split('_')[1] + '_' + sectionId.split('_')[3];

  var shippingCompany = $('#' + prefixId + "_out_company_name").val();
  var shippingAttRef = $('#' + prefixId + "_out_display_name").val();
  var shippingAddress1 = $('#' + prefixId + "_out_address_1").val();
  var shippingAddress2 = $('#' + prefixId + "_out_address_2").val();
  var shippingAddress3 = $('#' + prefixId + "_out_address_3").val();
  var shippingState = $('#' + prefixId + "_out_state").val();
  var shippingSuburb = $('#' + prefixId + "_out_suburb").val();
  var shippingPostCode = $('#' + prefixId + "_out_postcode").val();
  var shippingPhone = $('#' + prefixId + "_out_phone").val();
  var shippingCountry = $('#' + prefixId + "_out_country").val();
  var shippingEmail = $('#' + prefixId + "_out_email").val();
  var shippingFax = $('#' + prefixId + "_out_fax").val();
  var flag = false;
  $('#pills-tabContent > div').each(function () {
    var salesType = $(this).attr('id');

    if (shippingCompany && $('#' + salesType + "_out_company_name").length) {
      flag = true;
      $('#' + salesType + "_out_company_name").val(shippingCompany);
    }

    if (shippingAttRef && $('#' + salesType + "_out_display_name").length) {
      flag = true;
      $('#' + salesType + "_out_display_name").val(shippingAttRef);
    }

    if (shippingAddress1 && $('#' + salesType + "_out_address_1").length) {
      flag = true;
      $('#' + salesType + "_out_address_1").val(shippingAddress1);
    }

    if (shippingAddress2 && $('#' + salesType + "_out_address_2").length) {
      flag = true;
      $('#' + salesType + "_out_address_2").val(shippingAddress2);
    }

    if (shippingAddress3 && $('#' + salesType + "_out_address_3").length) {
      flag = true;
      $('#' + salesType + "_out_address_3").val(shippingAddress3);
    }

    if (shippingState && $('#' + salesType + "_out_state").length) {
      flag = true;
      $('#' + salesType + "_out_state").val(shippingState.toUpperCase());
    }
    if (shippingSuburb && $('#' + salesType + "_out_suburb").length) {
      flag = true;
      $('#' + salesType + "_out_suburb").val(shippingSuburb);
    }

    if (shippingPostCode && $('#' + salesType + "_out_postcode").length) {
      flag = true;
      $('#' + salesType + "_out_postcode").val(shippingPostCode);
    }

    if (shippingPhone && $('#' + salesType + "_out_phone").length) {
      flag = true;
      $('#' + salesType + "_out_phone").val(shippingPhone);
    }

    if (shippingEmail && $('#' + salesType + "_out_email").length) {
      flag = true;
      $('#' + salesType + "_out_email").val(shippingEmail);
    }

    if (shippingFax && $('#' + salesType + "_out_fax").length) {
      flag = true;
      $('#' + salesType + "_out_fax").val(shippingFax);
    }

    if (shippingCountry && $('#' + salesType + "_out_country").length) {
      flag = true;
      $('#' + salesType + "_out_country").val(shippingCountry);
    }
  });
  return flag;
}

function copyBrandsInfo(sectionId) {

  var prefixId = sectionId.split('_')[1] + '_' + sectionId.split('_')[3];
  var shippingCompany = $('#' + prefixId + "_out_company_name").val();
  var shippingAttRef = $('#' + prefixId + "_out_display_name").val();
  var shippingAddress1 = $('#' + prefixId + "_out_address_1").val();
  var shippingAddress2 = $('#' + prefixId + "_out_address_2").val();
  var shippingAddress3 = $('#' + prefixId + "_out_address_3").val();
  var shippingState = $('#' + prefixId + "_out_state").val();
  var shippingSuburb = $('#' + prefixId + "_out_suburb").val();
  var shippingPostCode = $('#' + prefixId + "_out_postcode").val();
  var shippingPhone = $('#' + prefixId + "_out_phone").val();
  var shippingCountry = $('#' + prefixId + "_out_country").val();
  var shippingEmail = $('#' + prefixId + "_out_email").val();
  var shippingFax = $('#' + prefixId + "_out_fax").val();

  var salesType = sectionId.split('_')[1];

  var flag = false;
  if (shippingCompany && $('#' + salesType + "_out_company_name").length) {
    flag = true;
    $('#' + salesType + "_out_company_name").val(shippingCompany);
  }

  if (shippingAttRef && $('#' + salesType + "_out_display_name").length) {
    flag = true;
    $('#' + salesType + "_out_display_name").val(shippingAttRef);
  }

  if (shippingAddress1 && $('#' + salesType + "_out_address_1").length) {
    flag = true;
    $('#' + salesType + "_out_address_1").val(shippingAddress1);
  }

  if (shippingAddress2 && $('#' + salesType + "_out_address_2").length) {
    flag = true;
    $('#' + salesType + "_out_address_2").val(shippingAddress2);
  }

  if (shippingAddress3 && $('#' + salesType + "_out_address_3").length) {
    flag = true;
    $('#' + salesType + "_out_address_3").val(shippingAddress3);
  }

  if (shippingState && $('#' + salesType + "_out_state").length) {
    flag = true;
    $('#' + salesType + "_out_state").val(shippingState.toUpperCase());
  }
  if (shippingSuburb && $('#' + salesType + "_out_suburb").length) {
    flag = true;
    $('#' + salesType + "_out_suburb").val(shippingSuburb);
  }

  if (shippingPostCode && $('#' + salesType + "_out_postcode").length) {
    flag = true;
    $('#' + salesType + "_out_postcode").val(shippingPostCode);
  }

  if (shippingPhone && $('#' + salesType + "_out_phone").length) {
    flag = true;
    $('#' + salesType + "_out_phone").val(shippingPhone);
  }

  if (shippingEmail && $('#' + salesType + "_out_email").length) {
    flag = true;
    $('#' + salesType + "_out_email").val(shippingEmail);
  }

  if (shippingFax && $('#' + salesType + "_out_fax").length) {
    flag = true;
    $('#' + salesType + "_out_fax").val(shippingFax);
  }

  if (shippingCountry && $('#' + salesType + "_out_country").length) {
    flag = true;
    $('#' + salesType + "_out_country").val(shippingCountry);
  }
  return flag;
}

export function goNext(cartId, salesType) {
  var result = EndUserDetailFormValidation(salesType);
  var response;
  if (result) {
    $.ajax({
      url: 'api/checkout/SetEndUserDetailPost?cartId=' + cartId,
      type: 'POST',
      data: $('#' + salesType).serialize(),
      async: false,
      datatype: "",
      success: function (output) {
        response = output;
      },
      error: function (request, status, error) {
        console.info(error);
        $('.btn' + salesType).showValidator(error, 'error', 'right');
      }
    });
  }
  return response;
}

export function closeAddrBook() {
  $('.endpopup .nav-link').unbind('click');
  $('.eu-copy-all-brands').unbind('click');
  $('end-user-ab-details').remove();
  $('#endusermodal').foundation('close');
}

export function EndUserDetailFormValidation(salesType) {

  var result = true;
  if ($('#' + salesType).length > 0) {
    $('#' + salesType + ' .form-row input.required').each(function () {
      if ($.trim($(this).val()).length == 0) {
        result = false;
        $(this).showValidator('This field must be filled', 'error', 'right');
      }
    });
  }
  return result;
}
